import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';

export const MotherSeries = () => {
    const { chartData } = useParentsInfoChartsDataContext();


    return (
        <SimpleBars
            title={'Numero da série da mãe'}
            horizontal={false}
            subtitles={chartData?.motherSeries?.map((item) => item.description)}
            values={chartData?.motherSeries?.map((item) => item.total  ||  0)}
        />
    );
};
